import { useEffect, useState } from "react";
import { homeContentApi } from "../api/services";
import { mergeHomeContent, HOME_FALLBACKS } from "../constants/homeDefaults";

export function useHomeContent() {
  const [content, setContent] = useState(HOME_FALLBACKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    homeContentApi
      .get()
      .then((res) => {
        if (!cancelled) {
          setContent(mergeHomeContent(res.data.data.content));
        }
      })
      .catch(() => {
        if (!cancelled) setContent(HOME_FALLBACKS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading };
}
